import CategoryTags from '~/components/Layout/CategoryTags.vue';
import { useGetTranslations } from '~/composables/useGetTranslations';
export default defineComponent({
  name: 'BlockCategoryTags',
  components: {
    CategoryTags: CategoryTags
  },
  props: {
    category: {
      type: Object,
      default: null
    }
  },
  setup: function setup(props) {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var listOfTags = computed(function () {
      var _props$category;
      return props === null || props === void 0 ? void 0 : (_props$category = props.category) === null || _props$category === void 0 ? void 0 : _props$category.tags;
    });
    return {
      listOfTags: listOfTags,
      translate: translate
    };
  }
});